import { render, staticRenderFns } from "./DialPad.vue?vue&type=template&id=61499b54&scoped=true"
import script from "./DialPad.vue?vue&type=script&lang=js"
export * from "./DialPad.vue?vue&type=script&lang=js"
import style0 from "./DialPad.vue?vue&type=style&index=0&id=61499b54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61499b54",
  null
  
)

export default component.exports